export default function getCareInsightsFeedbackMetadata({ isSupervisor }: { isSupervisor?: boolean }) {
  return {
    schema: {
      type: 'object',
      properties: {
        feedbackStars: {
          title: isSupervisor
            ? 'How would you rate the quality of the insights? (Rating as supervisor)'
            : 'How would you rate the quality of the insights?',
          name: 'feedbackStars',
          type: 'number',
          testID: 'SatisfactionSurvey',
        },
        wordCloudSelection1to3stars: {
          title: 'Anything specific?',
          name: 'wordCloudSelection1to3stars',
          type: 'string',
          enum: ['Inaccurate', 'Not specific', 'Missing nuance'],
          condition: {
            parentField: 'feedbackStars',
            parentValue: [1, 2, 3],
          },
        },
        wordCloudSelection4to5stars: {
          title: 'Anything specific?',
          name: 'wordCloudSelection4to5stars',
          type: 'string',
          enum: ['Accurate', 'Comprehensive', 'Insightful'],
          condition: {
            parentField: 'feedbackStars',
            parentValue: [4, 5],
          },
        },
        tellUsMore: {
          name: 'tellUsMore',
          type: 'string',
          title: 'Tell us more (optional)',
          placeholder: 'Anything else?',
          numberOfLines: 1,
          condition: {
            parentField: 'feedbackStars',
            parentValue: [1, 2, 3, 4, 5],
          },
        },
      },
    },
    uiSchema: {
      'ui:order': ['feedbackStars', 'wordCloudSelection1to3stars', 'wordCloudSelection4to5stars', 'tellUsMore'],
      feedbackStars: {
        'ui:widget': 'feedbackStars',
        'ui:options': {
          customStyles: {
            baseInput: { marginBottom: 24 },
            justifyStars: 'flex-start',
            size: 22,
            padding: '0',
          },
        },
      },
      wordCloudSelection1to3stars: {
        'ui:widget': 'wordCloud',
        'ui:options': {
          customStyles: {
            baseInput: { marginBottom: 24 },
            flexCloudsStart: true,
          },
        },
      },
      wordCloudSelection4to5stars: {
        'ui:widget': 'wordCloud',
        'ui:options': {
          customStyles: {
            baseInput: { marginBottom: 24 },
            flexCloudsStart: true,
          },
        },
      },
      tellUsMore: {
        'ui:widget': 'textarea',
        'ui:options': {
          baseInputStyle: { marginBottom: 24 },
        },
      },
    },
  }
}
